module.exports = __webpack_public_path__ + "static/media/charmark-green.38ccdd3d.svg";